import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import GuardiansTable from '../../components/guardians/GuardiansTable';
const GuardiansArchive = () => (<WrapperSection><GlobalBreadcrumbs /><GuardiansTable isArchive /></WrapperSection>);
export default GuardiansArchive;
